import React, { useEffect, useState } from "react";
import "./CaixaLista.scss";
import UtilServices from "@services/UtilServices";

export default function CaixaLista({
  icon = "",
  title = "",
  lista = [],
  setLista = () => null,
  iconMais = {
    icon: "",
    onClick: () => null,
  },
  className = "",
  onClick = () => null,
  theme = "1",
  disabled = false,
}) {
  function handleClick(e, automatic = false) {
    //Ativa o item na lista
    let novaLista = [];
    let item = lista.find((item) => item.id === e.id);

    if (item) {
      if (item?.ativo) {
        UtilServices.setStorage("clickcaixaactive", []);
        novaLista = lista.map((item) => ({
          ...item,
          ativo: false,
        }));
        item.ativo = false;
      } else {
        item.ativo = true;
        novaLista = lista.map((item) => ({
          ...item,
          ativo: item.id === e.id,
        }));

        UtilServices.setStorage(
          "clickcaixaactive",
          novaLista.find((item) => item.id === e.id),
        );
      }
      setLista(lista);
    }

    if (automatic) return;
    //Retorno.
    onClick(item);
  }
  return (
    <div className="caixalista">
      <div className="titulo">
        {icon}
        <p>{title}</p>
      </div>
      <div className="lista">
        <>
          {Object.values(lista).map((item, index) => (
            <div
              className={`itens ${item?.ativo ? "ativo" : ""}`}
              key={index}
              onClick={() => {
                handleClick(item);
              }}
            >
              {Object.entries(item).map(([chave, valor], i) => {
                if (valor == null || valor?.desc == null) return null;
                return (
                  <div
                    key={i}
                    onClick={() =>
                      typeof valor === "object" && valor?.onClick?.(valor)
                    }
                    className={`${valor?.className} ${valor?.title}`}
                    style={{
                      ...valor?.style,
                      cursor: typeof valor === "object" ? "pointer" : null,
                      color: valor?.color,
                    }}
                    data-tooltip-id="tooltip-001"
                    data-tooltip-html={valor?.title ? valor?.title : ""}
                  >
                    {/* somente texto */}
                    {typeof valor === "string" &&
                    (valor.includes("<i") || valor.includes("<svg"))
                      ? UtilServices.stringToJsx(valor)
                      : typeof valor === "string" && <p>{valor}</p>}

                    {/* texto objeto */}
                    {typeof valor === "object" &&
                    (valor?.desc?.includes("<i") ||
                      valor?.desc.includes("<svg")) ? (
                      UtilServices.stringToJsx(valor?.desc)
                    ) : (
                      <p>{valor?.desc}</p>
                    )}
                  </div>
                );
              })}
            </div>
          ))}
          {Object.values(lista).length === 0 && (
            <div
              style={{
                color: "var(--color-01)",
                textAlign: "center",
              }}
            >
              <p>
                <span style={{ fontFamily: "Roboto Bold" }}>
                  Sem dados disponíveis...
                </span>
                <br /> Clique no "+" para cadastrar empresas.
              </p>
            </div>
          )}
        </>
      </div>
      {iconMais?.icon && (
        <div className="icon-mais passo-4 relative">
          <div
            style={{
              cursor: "pointer",
            }}
            onClick={() => iconMais?.onClick?.()}
            data-tooltip-id="tooltip-001"
            data-tooltip-html={iconMais?.title ? iconMais?.title : ""}
          >
            {UtilServices.stringToJsx(iconMais?.icon)}
          </div>
          <div className="absolute right-3 top-[6px]">
            <p className="text-sm" style={{ color: "#CACACA" }}>
              ({Object.values(lista).length} Itens)
            </p>
          </div>
        </div>
      )}
    </div>
  );
}
